module.exports = __webpack_public_path__ + "static/media/email.7124f9f9.svg";